(function () {
  'use strict';

  const MOBILE_MQ = '(max-width: 989px)';
  const RATIO = 4 / 3;

  const isProductPage = () =>
    document.body.classList.contains('template-product') ||
    document.body.classList.contains('nicha-product-page') ||
    /\/products\//.test(window.location.pathname || '');

  const isMobile = () => window.matchMedia(MOBILE_MQ).matches;

  const getGallery = () =>
    document.querySelector('media-gallery.product__media-gallery, .product__media-gallery');

  const getViewer = (gallery) =>
    gallery?.querySelector('slider-component.slider-mobile-gutter, slider-component[id^="GalleryViewer"]') ||
    gallery?.querySelector('slider-component');

  const getItems = (gallery) => {
    const viewer = getViewer(gallery);
    const root = viewer || gallery;
    return [...root.querySelectorAll('.product__media-item, li.product__media-item')];
  };

  const measureWidth = (gallery) => {
    const viewer = getViewer(gallery);
    const wrapper = gallery.closest('.product__media-wrapper, .grid__item.product__media-wrapper');
    const list = gallery.querySelector('.product__media-list, ul.product__media-list');
    const active = gallery.querySelector('.product__media-item.is-active');

    const candidates = [
      viewer?.clientWidth,
      wrapper?.clientWidth,
      list?.clientWidth,
      active?.clientWidth,
      gallery.clientWidth,
      document.documentElement.clientWidth,
    ];

    for (const value of candidates) {
      if (value && value > 40) return value;
    }

    return 0;
  };

  const applyFrameToEl = (el, frameH) => {
    if (!el) return;
    el.style.setProperty('padding-top', '0', 'important');
    el.style.setProperty('padding-bottom', '0', 'important');
    el.style.setProperty('height', frameH, 'important');
    el.style.setProperty('min-height', frameH, 'important');
    el.style.setProperty('max-height', frameH, 'important');
    el.style.setProperty('aspect-ratio', 'unset', 'important');
    el.style.setProperty('position', 'relative', 'important');
    el.style.setProperty('overflow', 'hidden', 'important');
    el.style.setProperty('box-sizing', 'border-box', 'important');
  };

  const applyImageStyles = (img) => {
    img.style.setProperty('position', 'absolute', 'important');
    img.style.setProperty('inset', '0', 'important');
    img.style.setProperty('width', '100%', 'important');
    img.style.setProperty('height', '100%', 'important');
    img.style.setProperty('max-width', '100%', 'important');
    img.style.setProperty('max-height', '100%', 'important');
    img.style.setProperty('object-fit', 'cover', 'important');
    img.style.setProperty('object-position', 'center center', 'important');
  };

  let applyTimer = null;

  const apply = () => {
    if (!isProductPage() || !isMobile()) return;

    const gallery = getGallery();
    if (!gallery || gallery.classList.contains('nicha-product-media-grid--active')) return;

    const width = measureWidth(gallery);
    if (!width) return;

    const frameH = `${Math.round(width * RATIO)}px`;
    document.documentElement.style.setProperty('--nicha-product-mobile-media-h', frameH);
    gallery.style.setProperty('--nicha-product-mobile-media-h', frameH);

    const viewer = getViewer(gallery);
    [viewer, gallery.querySelector('.product__media-list, ul.product__media-list')].forEach((el) => {
      applyFrameToEl(el, frameH);
    });

    getItems(gallery).forEach((item) => {
      applyFrameToEl(item, frameH);
      item.querySelectorAll(
        '.product__media, .product__media.global-media-settings, .product__modal-opener, modal-opener, .deferred-media, .product__media-container'
      ).forEach((el) => applyFrameToEl(el, frameH));

      item.querySelectorAll('img').forEach((img) => {
        applyImageStyles(img);
        if (img.dataset.nichaMobileMediaBound !== '1') {
          img.dataset.nichaMobileMediaBound = '1';
          if (!img.complete) {
            img.addEventListener('load', () => scheduleApply(), { once: true });
          }
        }
      });
    });
  };

  const scheduleApply = () => {
    clearTimeout(applyTimer);
    applyTimer = setTimeout(apply, 50);
  };

  const bindGallery = (gallery) => {
    if (!gallery || gallery.dataset.nichaMobileMediaBound === '1') return;
    gallery.dataset.nichaMobileMediaBound = '1';

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(scheduleApply).observe(gallery, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden'],
      });
    }
  };

  const init = () => {
    if (!isProductPage()) return;
    const gallery = getGallery();
    if (!gallery) return;
    bindGallery(gallery);
    apply();
  };

  const boot = () => {
    init();
    [120, 400, 900, 1800, 3500].forEach((delay) => setTimeout(init, delay));
  };

  window.NichaProductMobileMedia = {
    apply,
    refresh: init,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', scheduleApply, { passive: true });

  if (typeof Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', () => setTimeout(init, 100));
  }
})();
